import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/InventoryTypesFull'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class InventoryTypesFullStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "InventoryTypesFullStore",
			variables: true,
		})
	}
}

export async function load_InventoryTypesFull(params) {
  await initClient()

	const store = new InventoryTypesFullStore()

	await store.fetch(params)

	return {
		InventoryTypesFull: store,
	}
}
